import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import Header from '../components/Header/Header';
import HeaderSecond from '../components/Header/HeaderSecond';
import Footer from '../components/Footer/Footer';
import FooterSecond from '../components/Footer/FooterSecond';
import '../styles/layouts/_mainLayout.scss';

const getSubpageTitle = (pathname) => {
  const exactMaps = {
    '/iletisim': 'İletişim',
    '/kvkk-basvuru': 'KVKK Başvurusu',
    '/mobil-gizlilik-politikasi': 'Mobil Gizlilik Politikası',
    '/haberler': 'Haberler',
    '/meclis-kararlari': 'Meclis Kararları',
    '/etkinlikler': 'Etkinlikler',
    '/ilanlar': 'İlanlar',
    '/faaliyet-raporlari': 'Faaliyet Raporları',
    '/mudurlerimiz': 'Müdürlerimiz',
    '/ihaleler': 'İhaleler',
    '/baskan': 'Başkan Özgeçmiş',
    '/baskan-gorev-yetkileri': 'Başkan Görev ve Yetkileri',
    '/nobetci-eczaneler': 'Nöbetçi Eczaneler',
    '/hizmet-rehberi/kutuphane-randevu': 'Kütüphane Randevu',
    '/hizmet-rehberi/kutuphane-randevu-iptal': 'Kütüphane Randevu İptali',
    '/hizmet-rehberi/spor-randevu': 'Spor Randevu',
    '/spor-randevu/odeme-basarili': 'Ödeme Başarılı',
    '/spor-randevu/odeme-basarisiz': 'Ödeme Başarısız',
    '/hizmet-rehberi/spor-randevu-iptal': 'Spor Randevu İptali',
    '/mobil-hesap-sil': 'Mobil Hesap Silme',
    '/nikah-islemleri': 'Nikah İşlemleri',
    '/misyon-vizyon-ve-temel-degerler': 'Misyon, Vizyon ve Temel Değerler',
    '/iskenderun-tarihi': 'İskenderun Tarihi',
    '/afet-acil-toplanma-alanlari': 'Afet Acil Toplanma Alanları',
    '/bilgiedinmekurum': 'Kurumsal Bilgi Edinme',
    '/bilgiedinmesahis': 'Kişisel Bilgi Edinme',
    '/meclis-uyeleri': 'Meclis Üyeleri',
    '/bize-bildir': 'Bize Bildir',
    '/kurumsal-kimlik': 'Kurumsal Kimlik',
    '/muhtarliklar': 'Muhtarlıklar',
    '/organizasyon-semasi': 'Organizasyon Şeması',
    '/sosyal-tesisler': 'Sosyal Tesislerimiz',
    '/duyurular': 'Duyurular',
    '/iskenderun-sehir-haritasi': 'İskenderun Şehir Haritası',
    '/arama': 'Arama Sonuçları',
    '/mobese-hizmetleri': 'Şehrimi İzliyorum',
    '/aile-koyu-kameralari': 'Aile Köyü Canlı Yayın',
    '/aile-koyu-kameralari-1': 'Park Alanı Kameraları',
    '/aile-koyu-kameralari-2': 'Ahşap Atölyesi Dışarısı Kameraları',
    '/aile-koyu-kameralari-3': 'Ahşap Atölyesi İçerisi Kameraları',
    '/bilgi-edinme-hakki': 'Bilgi Edinme Hakkı',
    '/mahalleler': 'Mahallem Gelişiyor',
    '/videolar': 'Video Galeri',
    '/projeler': 'Projelerimiz',
    '/temizlik-hizmetleri': 'Temizlik Hizmetleri',
    '/baskanla-fotografim': 'Başkanla Fotoğrafım'
  };

  const cleanPath = pathname.replace(/\/$/, '');
  const lowerPath = cleanPath.toLowerCase();

  // Try finding in exact maps
  for (const key of Object.keys(exactMaps)) {
    if (key.toLowerCase() === lowerPath) {
      return exactMaps[key];
    }
  }

  // Dynamic prefix matches
  if (lowerPath.startsWith('/projeler')) return 'Projelerimiz';
  if (lowerPath.startsWith('/haberler')) return 'Haberler';
  if (lowerPath.startsWith('/etkinlikler')) return 'Etkinlikler';
  if (lowerPath.startsWith('/ihaleler')) return 'İhaleler';
  if (lowerPath.startsWith('/ilanlar')) return 'İlanlar';
  if (lowerPath.startsWith('/duyurular')) return 'Duyurular';
  if (lowerPath.startsWith('/meclis-kararlari')) return 'Meclis Kararları';
  if (lowerPath.startsWith('/mahalleler')) return 'Mahallem Gelişiyor';
  if (lowerPath.startsWith('/mudurlukler')) return 'Müdürlüklerimiz';
  if (lowerPath.startsWith('/mudurler')) return 'Müdürlerimiz';

  return null;
};

function MainLayout({ children, title, customHeader, customFooter }) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  const HeaderComponent = customHeader || Header;
  const FooterComponent = customFooter || Footer;
  
  const displayTitle = title || getSubpageTitle(location.pathname);

  return (
    <div className={`main-layout ${isHomePage ? 'home-layout' : 'subpage-layout'}`}>
      <HeaderComponent />
      {displayTitle && !isHomePage && (
        <div className="subpage-header">
          <div className="subpage-header-container">
            <div className="subpage-title-wrapper">
              <h1>{displayTitle}</h1>
            </div>
            <div className="breadcrumbs">
              <Link to="/">Ana Sayfa</Link>
              <span className="separator">/</span>
              <span className="current">{displayTitle}</span>
            </div>
          </div>
        </div>
      )}
      <main className="main-content">
        {children}
      </main>
      <FooterComponent />
    </div>
  );
}

export default MainLayout;
